/* ES LensAdvisor bridge (V2-safe)
   Purpose:
   - When arriving on PDP with ?openLA=1 (from QuickView "SELECT LENSES"), automatically open the LensAdvisor modal.
   - Avoid conflicts with LensAdvisor v2 (App Block) by:
       * Waiting for LensAdvisor init completion
       * Retrying until the modal is actually open
       * Not removing the openLA param until success
   - Safe no-op if LensAdvisor isn't present.
*/
(function(){
  'use strict';

  try {
    var qs = (window.location && window.location.search) || '';
    var openLA = (qs.indexOf('openLA=1') !== -1 || qs.indexOf('openLA=true') !== -1);
    if (!openLA) return;

    // If QuickView passed a specific variant (?variant=123), wait until PDP is set to it.
    var wantedVariant = '';
    try {
      wantedVariant = (new URL(window.location.href)).searchParams.get('variant') || '';
      wantedVariant = String(wantedVariant || '').trim();
    } catch(e) {}

    // --- One-press Back to return to the originating list/search page ---
    // (kept from previous versions)
    var __esOriginUrl = '';
    var __esOriginOk = false;
    try {
      __esOriginUrl = sessionStorage.getItem('es_la_origin_url') || '';
      var __ts = parseInt(sessionStorage.getItem('es_la_origin_ts') || '0', 10);
      if (__esOriginUrl && __ts && (Date.now() - __ts) <= 30 * 60 * 1000) {
        __esOriginOk = true;
      }
    } catch(e2) {}

    function stillOnProduct(){
      try { return /^\/products\//.test(window.location.pathname || ''); } catch(e3) { return false; }
    }

    function isLaModalOpen(){
      try {
        var el = document.querySelector(
          '#la-prescription-modal, .la-prescription-modal, .la-prescription-modal-container, .la-modal'
        );
        if (!el) return false;
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
      } catch(e4) { return false; }
    }


    function forceLaLayout(){
      try {
        var modal = document.querySelector('#la-prescription-modal, .la-prescription-modal');
        if (!modal) return;

        // Mimic a user interaction that usually triggers layout stabilization.
        try {
          if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex','-1');
          modal.focus({ preventScroll: true });
        } catch(e1) {}

        // Force reflow
        try { void modal.offsetHeight; } catch(e2) {}

        // Some apps recalc layout on resize
        try { window.dispatchEvent(new Event('resize')); } catch(e3) {}
        setTimeout(function(){ try { window.dispatchEvent(new Event('resize')); } catch(e4) {} }, 60);
        setTimeout(function(){ try { window.dispatchEvent(new Event('resize')); } catch(e5) {} }, 180);

        // Nudge modal scroll container to trigger repaint
        try {
          var sc = modal.querySelector('.la-prescription-modal-body, .la-modal-body, .la-step, [data-la-scroll]');
          if (sc) {
            var st = sc.scrollTop;
            sc.scrollTop = st + 1;
            sc.scrollTop = st;
          }
        } catch(e6) {}
      } catch(e7) {}
    }

    (function setupBackSkip(){
      try {
        if (!__esOriginOk) return;
        var ref = (document.referrer || '').split('#')[0];
        var want = String(__esOriginUrl).split('#')[0];
        var enable = openLA || (!!ref && ref === want);
        if (!enable) return;
        var didSkip = false;
        function skipToOrigin(){
          if (didSkip) return;
          if (!__esOriginUrl) return;
          if (!stillOnProduct()) return;
          didSkip = true;
          try { window.location.replace(__esOriginUrl); } catch(e5) { window.location.href = __esOriginUrl; }
        }
        function onBackLike(){
          setTimeout(function(){
            if (stillOnProduct() && !isLaModalOpen()) skipToOrigin();
          }, 0);
        }
        window.addEventListener('popstate', onBackLike, true);
        window.addEventListener('hashchange', onBackLike, true);
      } catch(e6) {}
    })();

    // --- Auto open logic ---
    var done = false;
    var lastClickAt = 0;
    var initComplete = false;

    function removeParam(){
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('openLA');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch(e7) {}
    }

    // LensAdvisor V2 events (doc): LensAdvizor:init:complete, LensAdvizor:selectLensModal:open
    // We use them to avoid clicking too early.
    try {
      document.addEventListener('LensAdvizor:init:complete', function(){
        initComplete = true;
        // Attempt immediately after init.
        tryOpen();
      });
      document.addEventListener('LensAdvizor:selectLensModal:open', function(){
        try { setTimeout(forceLaLayout, 0); setTimeout(forceLaLayout, 120); } catch(e0) {}
        if (done) return;
        done = true;
        removeParam();
      });
    } catch(e8) {}

    function isVisible(el){
      try { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); } catch(e9) { return false; }
    }

    function getVariantInput(){
      try {
        return document.querySelector('form[action^="/cart"] [name="id"], .product-form [name="id"], [name="id"]');
      } catch(e10) { return null; }
    }

    function ensureVariantSelected(){
      if (!wantedVariant) return true;
      var el = getVariantInput();
      if (!el) return false;
      var current = '';
      try { current = String(el.value || '').trim(); } catch(e11) {}
      if (current === wantedVariant) return true;
      try {
        el.value = wantedVariant;
        if (String(el.tagName || '').toUpperCase() === 'SELECT') {
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } catch(e12) {}
      return false;
    }

    function findOpenButton(){
      // Primary selector used in many LensAdvisor installs
      var btn = document.querySelector('#la-select-lenses-btn');
      if (btn) return btn;
      // Common class fallback
      btn = document.querySelector('.la-select-lenses-btn');
      if (btn) return btn;
      // Some builds use data attributes
      btn = document.querySelector('[data-la-select-lenses], [data-lensadvizor-select-lenses]');
      return btn;
    }

    function markDoneIfOpen(){
      if (done) return true;
      if (isLaModalOpen()) {
        try { setTimeout(forceLaLayout, 0); setTimeout(forceLaLayout, 120); } catch(e0) {}
        done = true;
        removeParam();
        return true;
      }
      return false;
    }

    function clickOpen(btn){
      try {
        btn.click();
        // Some integrations bind late; dispatching helps.
        try { btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); } catch(e13) {}
      } catch(e14) {}
    }

    function tryOpen(){
      if (done) return true;
      if (!stillOnProduct()) return false;
      if (markDoneIfOpen()) return true;

      // Wait for the correct variant (if specified) before opening.
      if (!ensureVariantSelected()) return false;

      var btn = findOpenButton();
      if (!btn || !isVisible(btn)) return false;

      // Avoid clicking too early: if init complete event exists, prefer waiting for it.
      // If we never get the event, still attempt after a short delay window.
      var t = Date.now();
      if (!initComplete && t - startAt < 1200) return false;

      // Throttle clicks so we don't spam.
      if (t - lastClickAt < 650) return false;
      lastClickAt = t;

      clickOpen(btn);
      try { setTimeout(forceLaLayout, 50); setTimeout(forceLaLayout, 220); } catch(e0) {}

      // Confirm shortly after click; if it didn't open, polling will retry.
      setTimeout(markDoneIfOpen, 200);
      setTimeout(markDoneIfOpen, 600);
      return false;
    }

    var startAt = Date.now();

    function start(){
      var tries = 0;
      var maxTries = 100; // 100 * 250ms = 25s
      var iv = setInterval(function(){
        tries++;
        if (done || tries >= maxTries) {
          clearInterval(iv);
          return;
        }
        tryOpen();
      }, 250);

      // React faster when the app injects DOM.
      try {
        var mo = new MutationObserver(function(){
          if (done) { try { mo.disconnect(); } catch(e15) {} return; }
          tryOpen();
        });
        mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
        setTimeout(function(){ try { mo.disconnect(); } catch(e16) {} }, 26000);
      } catch(e17) {}

      // Handle bfcache restore (Safari/back-forward cache)
      window.addEventListener('pageshow', function(){
        if (done) return;
        // If page restored from cache, attempt again.
        tryOpen();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  } catch(e18) {}
})();


/* ES_LA_OOS_GUARD
   Keep LensAdvisor "SELECT LENSES" hidden when the currently selected variant is out of stock.
   - Does NOT rely on LensAdvisor admin injectors.
   - Uses ES_PDP_VARIANTS (set in product template) + current variant id from the add-to-cart form.
*/
(function(){
  'use strict';

  function q(sel, root){ return (root || document).querySelector(sel); }
  function qa(sel, root){
    var n = (root || document).querySelectorAll(sel);
    return Array.prototype.slice.call(n || []);
  }
  function isVisible(el){
    try { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
    catch(e){ return false; }
  }

  function getVariantId(){
    var el = q('form[action="/cart/add"] [name="id"]');
    if (el && el.value) return parseInt(el.value, 10);
    el = q('#ProductSelect') || q('#productSelect') || q('select[name="id"]');
    if (el && el.value) return parseInt(el.value, 10);
    return null;
  }

  function findVariant(id){
    var list = window.ES_PDP_VARIANTS || null;
    if (!list || !id) return null;
    for (var i=0; i<list.length; i++){
      if (Number(list[i].id) === Number(id)) return list[i];
    }
    return null;
  }

  function themeIndicatesOOS(){
    // Visible "Out of stock" blocks (theme variants)
    var sold = q('.shop-button-soldout') || q('.shop-button-soldout *');
    if (sold){
      var block = (sold.closest && sold.closest('.shop-button-soldout')) ? sold.closest('.shop-button-soldout') : sold;
      if (isVisible(block)) return true;
    }

    // Disabled submit button or text change
    var btn = q('form[action="/cart/add"] button[type="submit"]') || q('form[action="/cart/add"] .engoj-btn-addtocart');
    if (btn){
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return true;
      var txt = String(btn.textContent || '').trim().toLowerCase();
      if (txt.indexOf('out of stock') !== -1 || txt.indexOf('sold out') !== -1 || txt.indexOf('unavailable') !== -1) return true;
    }

    // Sticky bar (if present)
    var stickySold = q('.sticky_addcart .shop-button-soldout') || q('.sticky_addcart button[disabled]');
    if (stickySold && isVisible(stickySold)) return true;

    return false;
  }

  function getLaButtons(){
    var sels = [
      '#la-select-lenses-btn',
      '.la-select-lenses-btn',
      '[data-la="select-lenses"]',
      '.la-action-select-lenses button'
    ];
    var out = [];
    for (var i=0; i<sels.length; i++){
      try { out = out.concat(qa(sels[i])); } catch(e) {}
    }
    // de-dupe
    return out.filter(function(el, idx, arr){ return arr.indexOf(el) === idx; });
  }

  var lastId = null;

  function update(){
    var laBtns = getLaButtons();
    if (!laBtns.length) return false;

    var id = getVariantId();
    var v = findVariant(id);

    var hide = false;
    if (v && v.available === false) hide = true;
    else if (v && v.available === true) hide = false;
    else hide = themeIndicatesOOS();

    for (var i=0; i<laBtns.length; i++){
      if (hide) laBtns[i].classList.add('es-la-hide');
      else laBtns[i].classList.remove('es-la-hide');
    }
    return true;
  }

  function kick(){
    update();
    setTimeout(update, 60);
    setTimeout(update, 180);
    setTimeout(update, 450);
  }

  // Observe DOM for LensAdvisor injection and layout updates
  try {
    var mo = new MutationObserver(function(){ kick(); });
    mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
    setTimeout(function(){ try { mo.disconnect(); } catch(e) {} }, 60000);
  } catch(e) {}

  // Listen to option changes (selectors + swatches)
  document.addEventListener('change', function(e){
    var t = e && e.target;
    if (!t) return;

    if (t.classList && t.classList.contains('single-option-selector')) { kick(); return; }
    if (t.name && t.name.indexOf('option-') === 0) { kick(); return; }
    if (t.name === 'id') { kick(); return; }
  }, true);

  // Poll as a fallback (covers cases where scripts set .value without change event)
  var start = Date.now();
  var poll = setInterval(function(){
    var id = getVariantId();
    if (id && id !== lastId){
      lastId = id;
      kick();
    } else if (Date.now() - start < 5000) {
      // initial stabilization
      kick();
    }
    if (Date.now() - start > 60000) clearInterval(poll);
  }, 400);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kick, { once: true });
  } else {
    kick();
  }
  window.addEventListener('pageshow', kick);
})();
